
    /**
     * Round value up with a custom radix.
     */
    function ceil(val, step){
        step = Math.abs(step || 1);
        return Math.ceil(val / step) * step;
    }

    module.exports = ceil;




//////////////////
// WEBPACK FOOTER
// ./~/mout/math/ceil.js
// module id = 1615
// module chunks = 0 1 2